module.exports = __webpack_public_path__ + "excl-white2.svg?b3605580885bc6157bb6804c8de1ef9b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excl-white2.svg
// module id = 935
// module chunks = 0